import { useAppSelector } from "@/OneLiners";
import { AppEnumHelper } from "@/Shared/Helpers";

export const useAppEnum = () => {

    const enums = useAppSelector(state => state.appState.enums);
    const appENumHelper = new AppEnumHelper(enums);

    const ActivityEnums = {
        ActivityStatusEnum: appENumHelper.ActivityStatusEnum(),
        ActivityPriorityEnum: appENumHelper.ActivityPriorityEnum(),
        TaskCategoryEnum: appENumHelper.TaskCategoryEnum(),
    };
    
    const ContactEnums = {
        CivilityEnum: appENumHelper.CivilityEnum(),
        ContactTypeEnum: appENumHelper.ContactTypeEnum(),
        UserPositionEnum: appENumHelper.UserPositionEnum(),
    };

    const DocumentEnums = {
        ResourceTypeEnum: appENumHelper.ResourceTypeEnum(),
        DocumentTypeEnum: appENumHelper.DocumentTypeEnum(),
        DocumentCategoryEnum: appENumHelper.DocumentCategoryEnum(),
    };
    
    const MandateEnums = {
        OperationTypeEnum: appENumHelper.OperationTypeEnum(),
        MandateTypeEnum: appENumHelper.MandateTypeEnum(),
        NeedStatusEnum : appENumHelper.NeedStatusEnum(),
        StandingEnum: appENumHelper.StandingEnum(),
        PropertyCategoryEnum: appENumHelper.PropertyCategoryEnum(),
        PropertyTypeEnum: appENumHelper.PropertyTypeEnum(),
        MatchingStatusEnum: appENumHelper.MatchingStatusEnum(),
    };

    const PropertyEnums = {
        OperationTypeEnum: appENumHelper.OperationTypeEnum(),
        StandingEnum: appENumHelper.StandingEnum(),
        PropertyConditionEnum: appENumHelper.PropertyConditionEnum(),
        AvailabilityEnum: appENumHelper.AvailabilityEnum(),
        PropertyTypeEnum: appENumHelper.PropertyTypeEnum(),
        PropertyCategoryEnum: appENumHelper.PropertyCategoryEnum(),
        MatchingStatusEnum: appENumHelper.MatchingStatusEnum(),
        PropertyFeatureTypeEnum : appENumHelper.PropertyFeatureTypeEnum(),
        PropertyFeatureCategoryEnum : appENumHelper.PropertyFeatureCategoryEnum(),
        PriceRangeEnum : appENumHelper.PriceRangeEnum(),
        PropertyUsageEnum : appENumHelper.PropertyUsageEnum()
    }

    const PublicationEnums = {
        AdSourceTypeEnum: appENumHelper.AdSourceTypeEnum(),
        AdSourceCategoryEnum: appENumHelper.AdSourceCategoryEnum(),
        PropertyTypeEnum: appENumHelper.PropertyTypeEnum(),
    }

    const NeedEnums = {
        OperationTypeEnum: appENumHelper.OperationTypeEnum(),
        StandingEnum: appENumHelper.StandingEnum(),
        PropertyCategoryEnum: appENumHelper.PropertyCategoryEnum(),
        PropertyTypeEnum: appENumHelper.PropertyTypeEnum(),
        NeedStatusEnum: appENumHelper.NeedStatusEnum(),
        MatchingStatusEnum: appENumHelper.MatchingStatusEnum(),
        PriceRangeEnum : appENumHelper.PriceRangeEnum(),
        PropertyUsageEnum : appENumHelper.PropertyUsageEnum()
    }

    const MatchingEnums = {
        MatchingStatusEnum: appENumHelper.MatchingStatusEnum(),
        propertyEnums : PropertyEnums,
        needEnums : NeedEnums,
    };

    const PermissionEnums = {
        ResourceTypeEnum: appENumHelper.ResourceTypeEnum(),
        UserRoleEnum: appENumHelper.UserRoleEnum(),
        AccessTypeEnum: appENumHelper.AccessTypeEnum()
    }

    const PersonViewEnums = {
        CivilityEnum: appENumHelper.CivilityEnum(),
        UserPositionEnum: appENumHelper.UserPositionEnum(),
    }

    const PlanningEnums = {
        PropertyCategoryEnum: appENumHelper.PropertyCategoryEnum(),
        PropertyTypeEnum: appENumHelper.PropertyTypeEnum(),
        PlanningTypeEnum: appENumHelper.PlanningTypeEnum(),
    }

    const TaskViewEnums = {
        TaskCategoryEnum: appENumHelper.TaskCategoryEnum(),
    }

    const TransactionEnums = {
        OperationTypeEnum: appENumHelper.OperationTypeEnum(),
        StandingEnum: appENumHelper.StandingEnum(),
        PropertyCategoryEnum: appENumHelper.PropertyCategoryEnum(),
        PropertyTypeEnum: appENumHelper.PropertyTypeEnum(),
        MatchingStatusEnum: appENumHelper.MatchingStatusEnum(),
        MandateTypeEnum: appENumHelper.MandateTypeEnum(),
    }

    const UserEnums = {
        CivilityEnum: appENumHelper.CivilityEnum(),
        UserPositionEnum: appENumHelper.UserPositionEnum(),
        UserRoleEnum: appENumHelper.UserRoleEnum(),
    }

    const LeaseEnums = {
        LeaseTypeEnum: appENumHelper.LeaseTypeEnum(),
        LeaseOptionEnum: appENumHelper.LeaseOptionEnum(),
        TransactionEnums
    }

    return {
        ActivityEnums,
        ContactEnums,
        DocumentEnums,
        MandateEnums,
        PropertyEnums,
        NeedEnums,
        MatchingEnums,
        PermissionEnums,
        PersonViewEnums,
        PlanningEnums,
        TaskViewEnums,
        TransactionEnums,
        UserEnums,
        LeaseEnums,
        PublicationEnums,
        hasEnums : !!Object.keys(enums ?? {}).length
    };
}